import { render } from "./HomeResearch.vue?vue&type=template&id=59c37d32&scoped=true"
import script from "./HomeResearch.vue?vue&type=script&lang=js"
export * from "./HomeResearch.vue?vue&type=script&lang=js"

import "./HomeResearch.vue?vue&type=style&index=0&id=59c37d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c37d32"]])

export default __exports__